// extracted by mini-css-extract-plugin
export default {"tooltip":"lo-z","sharingV2":"mo-z","sharingIconsV2":"no-z","links":"oo-z","link":"po-z","facebookV2":"qo-z","twitterV2":"ro-z","pinterestV2":"so-z"};